import React, { useEffect, useState } from "react";
import { FaChevronDown } from "react-icons/fa";
import { getFaq } from "../services/cmsServices";

const porPagina = 5000;

const SecaoFAQ = () => {
  const [pagina, setPagina] = useState(1);
  const [abertoIndex, setAbertoIndex] = useState(null);
  const [faqs, setFaqs] = useState([]);
  const [carregando, setCarregando] = useState(true);
  const [erro, setErro] = useState(null);

  useEffect(() => {
    const carregarFaqs = async () => {
      try {
        const dados = await getFaq();
        const ativos = dados.filter(f => f.ativo); // só mostra os que estão ativos
        const ordenados = ativos.sort((a, b) => (a.ordem ?? 0) - (b.ordem ?? 0));
        setFaqs(ordenados);
      } catch (err) {
        console.error("Erro ao carregar FAQ:", err);
        setErro("Não foi possível carregar os dados.");
      } finally {
        setCarregando(false);
      }
    };

    carregarFaqs();
  }, []);

  const totalPaginas = Math.ceil(faqs.length / porPagina);
  const faqsPagina = faqs.slice((pagina - 1) * porPagina, pagina * porPagina);

  return (
    <section className="py-12 px-4 max-w-7xl mx-auto">
      <div className="text-center mb-8">
        <h2 className="text-5xl font-bold relative inline-block after:block after:w-64 after:h-[3px] after:bg-yellow-400 after:mt-2 after:mx-auto">
          FAQ
        </h2>
        <p className="text-center text-gray-700">Dúvidas frequentes</p>
      </div>

      {carregando ? (
        <p className="text-center text-gray-600">Carregando perguntas...</p>
      ) : erro ? (
        <p className="text-center text-red-600">{erro}</p>
      ) : (
        <div className="space-y-3">
          {faqsPagina.map((item, idx) => {
            const globalIdx = (pagina - 1) * porPagina + idx;
            const isAberto = abertoIndex === globalIdx;
            return (
              <div key={item.id}>
                <button
                  onClick={() => setAbertoIndex(isAberto ? null : globalIdx)}
                  className="flex justify-between w-full px-4 py-3 text-sm font-semibold text-left bg-gray-100 rounded hover:bg-gray-200 focus:outline-none"
                  aria-expanded={isAberto}
                >
                  <span>{item.pergunta}</span>
                  <FaChevronDown
                    className={`w-4 h-4 transition-transform duration-200 ${isAberto ? "rotate-180" : ""}`}
                  />
                </button>
                {isAberto && (
                  <div
                    className="px-4 pt-2 pb-3 text-sm text-gray-700 bg-gray-50 border-l border-yellow-300 justify-html"
                    dangerouslySetInnerHTML={{ __html: item.resposta }}
                  />
                )}
              </div>
            );
          })}
        </div>
      )}
    </section>
  );
};

export default SecaoFAQ;
